import React, { useEffect, useMemo, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useStores } from "../../stores/root-store";
import { OfferTypeEnum } from "../../stores/index.d";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { IProductOffer } from "../../stores/productOffer";
import { AppConfig } from "../../AppConfig";
import { getOfferDescription } from "../../utils/functions";

const OffersBanner = () => {
  const { productOfferStore } = useStores();
  const { liveOffers, fetchLiveOffers } = productOfferStore;
  const sliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    fetchLiveOffers();
  }, []);

  // Ensure unique offers based on `offerId` or another unique property
  const uniqueOffers = useMemo(
    () => { return liveOffers},
    [liveOffers, liveOffers?.length]
  );

  const getEnumNameByValue = (value: number): string | undefined => {
    return OfferTypeEnum[value];
  };

  // Slick slider settings
  const settings = {
    dots: true,
    infinite: uniqueOffers?.length > 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: uniqueOffers?.length >= 3 ? 3 : uniqueOffers.length,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: uniqueOffers?.length >= 2 ? 2 : uniqueOffers.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {uniqueOffers?.length > 0 && (
        <div
          className="mb-5 offer-bg-cover rounded-4"
          style={{
            width: "90%",
            margin: "auto",
            marginTop: "20px",
            position: "relative",
          }}
        >
          {/* Custom Navigation Buttons */}
          {uniqueOffers?.length > 1 && (
            <>
              {" "}
              <button
                onClick={() => sliderRef.current?.slickPrev()}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "-15px",
                  zIndex: 1,
                  transform: "translateY(-50%)",
                  background: "#212629c4",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <button
                onClick={() => sliderRef.current?.slickNext()}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "-15px",
                  zIndex: 1,
                  transform: "translateY(-50%)",
                  background: "#212629c4",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </>
          )}

          {/* Slider */}
          <Slider ref={sliderRef} {...settings}>
            {uniqueOffers.map((offer: IProductOffer) => (
              <div key={offer.productOfferId}>
                <div
                  style={{
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                    maxWidth: "40rem",
                  }}
                >
                  {/* Image Section */}
                  <img
                    className="product-image"
                    src={
                      offer.product.productImagePath
                        ? `${AppConfig.APIBaseUrl}${offer.product.productImagePath}`
                        : "https://via.placeholder.com/300x200?text=Offer+Image"
                    }
                    alt={getEnumNameByValue(offer.offerType)}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      marginBottom: "10px",
                    }}
                  />

                  {/* Offer Details */}

                  <h3
                    style={{
                      fontSize: "1.2em",
                      fontWeight: "bold",
                      color: "#fff",
                      marginBottom: "10px",
                    }}
                  >
                    {offer.product?.productName}
                  </h3>
                  <div className="text-white">{getOfferDescription(offer)}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

export default OffersBanner;
